// eslint-disable-next-line arrow-body-style
const cm = (...strings) => {
  return strings.reduce((result, currentString) => {
    // Check if the current string is not null and not empty
    if (currentString && currentString.trim() !== '') {
      // Append the current string to the result with a white space separator
      return `${result} ${currentString.trim()}`;
    }
    // If the current string is null or empty, return the result as it is
    return result;
  }, '').trim(); // Trim to remove leading and trailing white spaces
};

export default cm;
